import { getBeehiveSdk } from '../graphql/beehive-sdk'

export async function getCategories() {
    const beehive = getBeehiveSdk()

    return await beehive.Categories()
}
